import { PL_VALUE_LANDING, PLTV_LANDINGS } from '../constants';
import { parseOnboardingPath } from '../../locales/languageConfig';

export const PLTV_DEFAULT_VALUE = 40.45;

const DEFAULT_PREDICTED_LTV_PRICE = PLTV_DEFAULT_VALUE;

const LTV_DATA = {
  'main-3months-0day-all-all': 53.52,
  'main-1month-0day-googlepay-all': 29.34,
  'main-1month-0day-card-all': 37.88,
  'main-1month-0day-applepay-all': 30.33,

  'upsell-3months-0day-all-all': 11.28,
  'upsell-1month-0day-all-all': 16.66,

  'main-1month-3day-all-all': 40.45,

  'main-1month-3day-googlepay-US': 34.33,
  'main-1month-3day-googlepay-ES': 39.67,
  'main-1month-3day-googlepay-AR': 25.88,
  'main-1month-3day-googlepay-JP': 127.47,
  'main-1month-3day-googlepay-CL': 55.46,
  'main-1month-3day-googlepay-IT': 47.19,
  'main-1month-3day-googlepay-TW': 51.12,
  'main-1month-3day-googlepay-BR': 10.95,
  'main-1month-3day-googlepay-EC': 29.58,
  'main-1month-3day-googlepay-FR': 79.56,
  'main-1month-3day-googlepay-UY': 51.52,
  'main-1month-3day-googlepay-CZ': 51.92,
  'main-1month-3day-googlepay-IL': 88.1,
  'main-1month-3day-googlepay-HN': 39.97,
  'main-1month-3day-googlepay-GT': 51.37,
  'main-1month-3day-googlepay-AU': 45.23,
  'main-1month-3day-googlepay-CA': 31.73,
  'main-1month-3day-googlepay-PE': 31.66,
  'main-1month-3day-googlepay-PA': 51.49,
  'main-1month-3day-googlepay-PR': 33.14,
  'main-1month-3day-googlepay-PY': 31.34,
  'main-1month-3day-googlepay-CR': 56.5,
  'main-1month-3day-googlepay-DO': 25.31,
  'main-1month-3day-googlepay-BG': 47.91,
  'main-1month-3day-googlepay-BE': 82.52,
  'main-1month-3day-googlepay-ZA': 17.1,
  'main-1month-3day-googlepay-CO': 15.39,
  'main-1month-3day-googlepay-KR': 37.35,
  'main-1month-3day-googlepay-MX': 27.52,
  'main-1month-3day-googlepay-NZ': 35.02,
  'main-1month-3day-googlepay-DE': 59.67,
  'main-1month-3day-googlepay-LT': 63.82,
  'main-1month-3day-googlepay-GR': 50.15,
  'main-1month-3day-googlepay-HR': 62.6,
  'main-1month-3day-googlepay-DK': 58.72,
  'main-1month-3day-googlepay-NO': 61.23,

  'main-1month-3day-card-US': 32.18,
  'main-1month-3day-card-ES': 36.58,
  'main-1month-3day-card-AR': 31.22,
  'main-1month-3day-card-JP': 93.83,
  'main-1month-3day-card-CL': 53.54,
  'main-1month-3day-card-IT': 46.42,
  'main-1month-3day-card-TW': 63.51,
  'main-1month-3day-card-BR': 10.38,
  'main-1month-3day-card-EC': 28.33,
  'main-1month-3day-card-FR': 54.74,
  'main-1month-3day-card-UY': 52.93,
  'main-1month-3day-card-CZ': 50.8,
  'main-1month-3day-card-IL': 99.42,
  'main-1month-3day-card-HN': 44.98,
  'main-1month-3day-card-GT': 53.85,
  'main-1month-3day-card-AU': 42.53,
  'main-1month-3day-card-CA': 28.12,
  'main-1month-3day-card-PE': 8.68,
  'main-1month-3day-card-PA': 36.26,
  'main-1month-3day-card-PR': 46.53,
  'main-1month-3day-card-PY': 27.77,
  'main-1month-3day-card-CR': 46.97,
  'main-1month-3day-card-DO': 30.17,
  'main-1month-3day-card-BG': 48.16,
  'main-1month-3day-card-BE': 75.36,
  'main-1month-3day-card-ZA': 26.02,
  'main-1month-3day-card-CO': 24.34,
  'main-1month-3day-card-KR': 43.68,
  'main-1month-3day-card-MX': 13.91,
  'main-1month-3day-card-NZ': 45.05,
  'main-1month-3day-card-DE': 48.42,
  'main-1month-3day-card-LT': 70.55,
  'main-1month-3day-card-GR': 28.31,
  'main-1month-3day-card-HR': 41.83,
  'main-1month-3day-card-DK': 48.93,
  'main-1month-3day-card-NO': 82.23,

  'main-1month-3day-applepay-US': 25.94,
  'main-1month-3day-applepay-ES': 30.65,
  'main-1month-3day-applepay-AR': 12.14,
  'main-1month-3day-applepay-JP': 126.11,
  'main-1month-3day-applepay-CL': 60.13,
  'main-1month-3day-applepay-IT': 55.19,
  'main-1month-3day-applepay-TW': 48.97,
  'main-1month-3day-applepay-BR': 18.99,
  'main-1month-3day-applepay-EC': 26.18,
  'main-1month-3day-applepay-FR': 53.3,
  'main-1month-3day-applepay-UY': 80.6,
  'main-1month-3day-applepay-CZ': 33.14,
  'main-1month-3day-applepay-IL': 60.65,
  'main-1month-3day-applepay-HN': 57.65,
  'main-1month-3day-applepay-GT': 38.93,
  'main-1month-3day-applepay-AU': 47.36,
  'main-1month-3day-applepay-CA': 30.85,
  'main-1month-3day-applepay-PE': 17.33,
  'main-1month-3day-applepay-PA': 63.97,
  'main-1month-3day-applepay-PR': 26.03,
  'main-1month-3day-applepay-PY': 36.65,
  'main-1month-3day-applepay-CR': 16.63,
  'main-1month-3day-applepay-DO': 17.57,
  'main-1month-3day-applepay-BG': 18.31,
  'main-1month-3day-applepay-BE': 50.5,
  'main-1month-3day-applepay-ZA': 24.58,
  'main-1month-3day-applepay-CO': 32.12,
  'main-1month-3day-applepay-KR': 35.43,
  'main-1month-3day-applepay-MX': 75.96,
  'main-1month-3day-applepay-NZ': 59.3,
  'main-1month-3day-applepay-DE': 75.35,
  'main-1month-3day-applepay-LT': 22.68,
  'main-1month-3day-applepay-GR': 44.65,
  'main-1month-3day-applepay-HR': 22.06,
  'main-1month-3day-applepay-DK': 45.48,
  'main-1month-3day-applepay-NO': 14.46,
};

const parsePlanName = (planName: string) => {
  const name = planName.toLowerCase();

  const isUpsell = name.includes('upsell');

  let duration: '1month' | '3months';
  if (name.includes('3month') || name.includes('3-month')) {
    duration = '3months';
  } else {
    duration = '1month';
  }

  let trialDuration: '0day' | '3day' | 'unsupported';
  const introDaysMatch = name.match(/intro(\d+)d/) || name.match(/-intro-.*-(\d+)-day-sub$/);
  if (introDaysMatch) {
    trialDuration = introDaysMatch[1] === '3' ? '3day' : 'unsupported';
  } else if (/-intro-.*-\d+-month-sub$/.test(name)) {
    trialDuration = '0day';
  } else if (name.includes('intro')) {
    trialDuration = '3day';
  } else {
    trialDuration = '0day';
  }

  return {
    type: isUpsell ? 'upsell' : 'main',
    duration,
    trialDuration,
  };
};

const normalizePaymentMethod = (paymentMethod: string): string => {
  const method = paymentMethod.toLowerCase();
  if (method.includes('google') || method.includes('googlepay')) return 'googlepay';
  if (method.includes('apple') || method.includes('applepay')) return 'applepay';
  if (method.includes('card')) return 'card';
  return 'all';
};

export const isUpsellGuidePlan = (plan: string): boolean => plan.toLowerCase().includes('guide');

export type PLTVCountrySource = 'geo' | 'link' | 'fallback';

export type PLTVCountry = {
  country: string | null;
  source: PLTVCountrySource;
};

export const resolvePLTVCountry = (
  geo: string | null | undefined,
  linkCountry: string | null | undefined,
): PLTVCountry => {
  if (geo) return { country: geo, source: 'geo' };
  if (linkCountry) return { country: linkCountry, source: 'link' };
  return { country: null, source: 'fallback' };
};

export const resolveLTVUserLocation = (userLocation: string | null | undefined): string => {
  const code = userLocation?.trim();
  return code || 'all';
};

const normalizeCountryCode = (country: string): string => {
  const countryCode = country.toUpperCase();
  const validCountries = [
    'US',
    'ES',
    'AR',
    'JP',
    'CL',
    'IT',
    'TW',
    'BR',
    'EC',
    'FR',
    'UY',
    'CZ',
    'IL',
    'HN',
    'GT',
    'AU',
    'CA',
    'PE',
    'PA',
    'PR',
    'PY',
    'CR',
    'DO',
    'BG',
    'BE',
    'ZA',
    'CO',
    'KR',
    'MX',
    'NZ',
    'DE',
    'LT',
    'GR',
    'HR',
    'DK',
    'NO',
  ];

  if (validCountries.includes(countryCode)) {
    return countryCode;
  }
  return 'all';
};

export const getPredictedLTVPrice = (
  plan: string,
  paymentMethod: string,
  userLocation: string,
  isUpsell: 'upsell' | 'checkout' = 'checkout',
  useDefaultValue = false,
) => {
  try {
    if (useDefaultValue) {
      return DEFAULT_PREDICTED_LTV_PRICE;
    }

    const planInfo = parsePlanName(plan);
    if (planInfo.trialDuration === 'unsupported') {
      return DEFAULT_PREDICTED_LTV_PRICE;
    }

    const normalizedPaymentMethod = normalizePaymentMethod(paymentMethod);
    const normalizedCountry = normalizeCountryCode(userLocation);
    const type = isUpsell === 'upsell' ? 'upsell' : planInfo.type;

    const specificKey = `${type}-${planInfo.duration}-${planInfo.trialDuration}-${normalizedPaymentMethod}-${normalizedCountry}`;
    let ltvValue = LTV_DATA[specificKey as keyof typeof LTV_DATA];

    if (ltvValue === undefined) {
      const fallbackKey = `${type}-${planInfo.duration}-${planInfo.trialDuration}-all-${normalizedCountry}`;
      ltvValue = LTV_DATA[fallbackKey as keyof typeof LTV_DATA];
    }

    if (ltvValue === undefined) {
      const fallbackKey = `${type}-${planInfo.duration}-${planInfo.trialDuration}-${normalizedPaymentMethod}-all`;
      ltvValue = LTV_DATA[fallbackKey as keyof typeof LTV_DATA];
    }

    if (ltvValue === undefined) {
      const fallbackKey = `${type}-${planInfo.duration}-${planInfo.trialDuration}-all-all`;
      ltvValue = LTV_DATA[fallbackKey as keyof typeof LTV_DATA];
    }

    return ltvValue ?? DEFAULT_PREDICTED_LTV_PRICE;
  } catch (error) {
    console.error('Error calculating predicted LTV price:', error);
    return DEFAULT_PREDICTED_LTV_PRICE;
  }
};

const normalizeLanding = (landing?: string | null): string => (landing ?? '').trim().toLowerCase();

export const isPLTVEnabled = (landing?: string | null): boolean => {
  const normalizedLanding = normalizeLanding(landing);

  return normalizedLanding !== '' && PLTV_LANDINGS.includes(normalizedLanding);
};

export const isPLValueLanding = (landing?: string | null): boolean =>
  normalizeLanding(landing) === PL_VALUE_LANDING;

export type ResolvePLTVPriceParams = {
  landing?: string | null;
  plan: string;
  paymentMethod?: string;
  userLocation?: string | null;
  useTimerDefault?: boolean;
};

export const resolvePLTVPriceForFlow = ({
  landing,
  plan,
  paymentMethod = 'card',
  userLocation,
  useTimerDefault = false,
}: ResolvePLTVPriceParams): number | undefined => {
  if (!isPLTVEnabled(landing) || isUpsellGuidePlan(plan)) {
    return undefined;
  }

  const ltvScope: 'upsell' | 'checkout' = plan.toLowerCase().includes('upsell')
    ? 'upsell'
    : 'checkout';
  const { linkCountry } = parseOnboardingPath(window.location.pathname);
  const { country } = resolvePLTVCountry(userLocation, linkCountry);

  return getPredictedLTVPrice(
    plan,
    paymentMethod,
    resolveLTVUserLocation(country),
    ltvScope,
    useTimerDefault,
  );
};
